import { useEffect } from "react";
import AdminIndex from "./pages/dashboard/admins/AdminIndex";
import ClientIndex from "./pages/dashboard/clients/Index";
import Home from "./pages/dashboard/Home";
import { Routes, Route, useLocation } from "react-router-dom";
import StatementIndex from "./pages/dashboard/statements/StatementIndex";
import SignIn from "./pages/auth/SignIn";
// import RequestIndex from "./pages/dashboard/requests/RequestIndex";
import ClientDetail from "./pages/dashboard/clients/ClientDetail";
import SystemLogsIndex from "./pages/activity logs/SystemLogs";
import "react-datepicker/dist/react-datepicker.css";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useDispatch } from "react-redux";
import { getCookie } from "cookies-next";
import { jwtDecode } from "jwt-decode";
import { authanticatedUser } from "./utils/helper";
import { logout } from "./redux/actions/auth";
import Settings from "./pages/dashboard/Settings";
import ResetPassword from "./pages/auth/ResetPassword";

function App() {
  const dispatch = useDispatch();
  const authUser = getCookie("loggedInUser");
  const location = useLocation();

  useEffect(() => {
    if (authanticatedUser) {
      // Decode the token to get the expiration time
      const decoded = jwtDecode(authanticatedUser.token);
      // Get the current time
      const currentTime = new Date().getTime() / 1000;
      // // Check if the token has expired
      if (decoded.exp < currentTime) {
        // Clear the user data from local storage
        dispatch(logout());
      } else {
        if (location.pathname === "/") {
          window.location = "/dashboard";
        }
      }
    }
  }, [dispatch, location.pathname]);


  return (
    <div className="App">
      {!authanticatedUser ? (
        <Routes>
          <Route path="/" element={<SignIn />} />
          <Route path="/resetpassword" element={<ResetPassword />} />
          <Route path="*" element={<SignIn />} />
        </Routes>
      ) : (
        <Routes>
          <Route exact path="/dashboard" index element={<Home />} />
          <Route path="/clients" element={<ClientIndex />} />
          <Route path="/profile" element={<ClientDetail />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="/admins" element={<AdminIndex />} />
          <Route path="/statements" element={<StatementIndex />} />
          <Route path="/system-logs" element={<SystemLogsIndex />} />
        </Routes>
      ) }
      <ToastContainer />
    </div>
  );
}

export default App;
